import { Link } from "react-router";
import PropTypes from "prop-types";
import { ReactComponent as Logo } from "../images/the-visionmonster.svg";
/**
 * Header component with navigation links.
 * @param {Object} props Component props
 */
export function Header(props) {
  return (
    <header title="Color Steps" className="header">
      <nav className="header-nav container">
        <Logo className="header-logo" alt="the visionmonster" />
        <span className="header-nav--name">Color Palette Tool</span>
        <ul className="header-nav--links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about/">About</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

Header.propTypes = {
  profile: PropTypes.shape({
    facebook: PropTypes.object,
    google: PropTypes.object,
  }),
  onSettingsClick: PropTypes.func,
  onProfileClick: PropTypes.func,
};
Header.defaultProps = {
  profile: undefined,
  onSettingsClick: () => {},
  onProfileClick: () => {},
};
